export default __webpack_public_path__ + "static/media/communication-favicon.44267b67.png";